declare var COMPILE_TIME_DEFAULT_JS_ASSETS_LOCATION: string;
declare var COMPILE_TIME_DEFAULT_VIDEOJS_LOCATION: string;
declare var COMPILE_TIME_DEFAULT_LOTTIE_JS_LOCATION: string;
declare var COMPILE_TIME_DEFAULT_PLAYER_SERVER_LOCATION: string;
declare var COMPILE_TIME_DEFAULT_CTA_STORAGE_LOCATION: string;

// tslint:disable:member-ordering
export class Config {
  static defaultJSAssetsLocation = COMPILE_TIME_DEFAULT_JS_ASSETS_LOCATION;

  static defaultVideoJSLocation = COMPILE_TIME_DEFAULT_VIDEOJS_LOCATION;
  static defaultLottieJSLocation = COMPILE_TIME_DEFAULT_LOTTIE_JS_LOCATION;
  static defaultPlayerServerUrl = COMPILE_TIME_DEFAULT_PLAYER_SERVER_LOCATION;
  static defaultCTAStorageUrl = COMPILE_TIME_DEFAULT_CTA_STORAGE_LOCATION;

  static vintomNamespace = "vintom";

  static placeholderStartMarker = "[";
  static placeholderEndMarker = "]";

  static placeholder = (name: string): string => `${Config.placeholderStartMarker}${name}${Config.placeholderEndMarker}`;

  static ctaStorageUrlPlaceholder = `${Config.placeholder("ctaStorageUrl")}`;
  static ctaTypePlaceholder = `${Config.placeholder("type")}`;
  static jsCTAStorageUrlPattern = `${Config.ctaStorageUrlPlaceholder}cta/${Config.ctaTypePlaceholder}/cta.js`;
  static htmlCTAStorageUrlPattern = `${Config.ctaStorageUrlPlaceholder}cta/${Config.ctaTypePlaceholder}/cta.html`;
  static cssCTAStorageUrlPattern = `${Config.ctaStorageUrlPlaceholder}cta/${Config.ctaTypePlaceholder}/cta.css`;
  
  static videoConfigurationUrl = (playerServerUrl: string, videoCode: string) => 
      `${playerServerUrl ? playerServerUrl : Config.defaultPlayerServerUrl}videoConfiguration/v2/${videoCode}`

  static videoLogUrl = (videoCode: string) => `${Config.defaultPlayerServerUrl}video/logError/${videoCode}`;

}
// tslint:enable:member-ordering
